import { render } from "./ThankYouCard.vue?vue&type=template&id=9be606be&scoped=true"
import script from "./ThankYouCard.vue?vue&type=script&lang=js"
export * from "./ThankYouCard.vue?vue&type=script&lang=js"

import "./ThankYouCard.vue?vue&type=style&index=0&id=9be606be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9be606be"

export default script